export default __webpack_public_path__ + "static/media/14_jesien_z_kaczka.17282bf4.png";